const actions = {

    MINING_DASHBOARD_DATA_BEGIN : 'MINING_DASHBOARD_DATA_BEGIN',
    MINING_DASHBOARD_DATA_SUCCESS: 'MINING_DASHBOARD_DATA_SUCCESS',
    MINING_DASHBOARD_DATA_ERR : 'MINING_DASHBOARD_DATA_ERR',

    MINING_CATEGORY_LIST_BEGIN : 'MINING_CATEGORY_LIST_BEGIN',
    MINING_CATEGORY_LIST_SUCCESS: 'MINING_CATEGORY_LIST_SUCCESS',
    MINING_CATEGORY_LIST_ERR : 'MINING_CATEGORY_LIST_ERR',

    MINING_REASON_LIST_BEGIN : 'MINING_REASON_LIST_BEGIN',
    MINING_REASON_LIST_SUCCESS: 'MINING_REASON_LIST_SUCCESS',
    MINING_REASON_LIST_ERR : 'MINING_REASON_LIST_ERR',

    MINING_LEADS_BEGIN : 'MINING_LEADS_BEGIN',
    MINING_LEADS_SUCCESS: 'MINING_LEADS_SUCCESS',
    MINING_LEADS_ERR : 'MINING_LEADS_ERR',

    MINING_DATA_BEGIN : 'MINING_DATA_BEGIN',
    MINING_DATA_SUCCESS: 'MINING_DATA_SUCCESS',
    MINING_DATA_ERR : 'MINING_DATA_ERR',
    MINING_DATA_RESET: 'MINING_DATA_RESET',

    MINING_PUSH_LEADS_BEGIN : 'MINING_PUSH_LEADS_BEGIN',
    MINING_PUSH_LEADS_SUCCESS: 'MINING_PUSH_LEADS_SUCCESS',
    MINING_PUSH_LEADS_ERR : 'MINING_PUSH_LEADS_ERR',


    getMiningDashboardDataBegin: () => {
        return {
            type: actions.MINING_DASHBOARD_DATA_BEGIN,
        };
    },

    getMiningDashboardDataSuccess: (data) => {
        return {
            type: actions.MINING_DASHBOARD_DATA_SUCCESS,
            data,
        };
    },

    getMiningDashboardDataErr: (err) => {
        return {
            type: actions.MINING_DASHBOARD_DATA_ERR,
            err,
        };
    },


    getMiningCategoryListBegin: () => {
        return {
            type: actions.MINING_CATEGORY_LIST_BEGIN,
        };
    },

    getMiningCategoryListSuccess: (data) => {
        return {
            type: actions.MINING_CATEGORY_LIST_SUCCESS,
            data,
        };
    },

    getMiningCategoryListErr: (err) => {
        return {
            type: actions.MINING_CATEGORY_LIST_ERR,
            err,
        };
    },

    
    getMiningReasonListBegin: () => {
        return {
            type: actions.MINING_REASON_LIST_BEGIN,
        };
    },

    getMiningReasonListSuccess: (data) => {
        return {
            type: actions.MINING_REASON_LIST_SUCCESS,
            data,
        };
    },

    getMiningReasonListErr: (err) => {
        return {
            type: actions.MINING_REASON_LIST_ERR,
            err,
        };
    },

    
    getMiningLeadsBegin: () => {
        return {
            type: actions.MINING_LEADS_BEGIN,
        };
    },

    getMiningLeadsSuccess: (data) => {
        return {
            type: actions.MINING_LEADS_SUCCESS,
            data,
        };
    },

    getMiningLeadsErr: (err) => {
        return {
            type: actions.MINING_LEADS_ERR,
            err,
        };
    },

    submitMiningDataBegin: () => {
        return {
            type: actions.MINING_DATA_BEGIN,
        };
    },

    submitMiningDataSuccess: (data) => {
        return {
            type: actions.MINING_DATA_SUCCESS,
            data,
        };
    },

    submitMiningDataErr: (err) => {
        return {
            type: actions.MINING_DATA_ERR,
            err,
        };
    },
    
    submitMiningDataReset : () => {
        return {
            type: actions.MINING_DATA_RESET,
        };
    },

    getMiningPushLeadsBegin : ()=>{
        return {
            type: actions.MINING_PUSH_LEADS_BEGIN
        }
    },
    getMiningPushLeadsSuccess : ()=>{
        return {
            type: actions.MINING_PUSH_LEADS_SUCCESS
        }
    },
    getMiningPushLeadsErr : ()=>{
        return {
            type: actions.MINING_PUSH_LEADS_ERR
        }
    }

};

export default actions;
